/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { CompanyService } from './custom/services/company/company.service';
import { Component, OnInit } from '@angular/core';
import { BootstrapService } from '@services/bootstrap/bootstrap.service';
import { AuthService } from '@services/auth/auth.service';
import { ThemeService } from '@services/theme/theme.service';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private bootstrapService: BootstrapService,
    private authService: AuthService,
    private companyService: CompanyService,
    private themeService: ThemeService
  ) {
    this.authService.addActionAfterLogon(() => this.initCompanyAfterLogon());
    this.bootstrapService.bootstrap();
  }

  ngOnInit(): void {
    this.initCompanyBeforeLogon().subscribe();
  }

  private initCompanyAfterLogon(): Observable<any> {
    return this.companyService.init({
      companyCode: this.getCompanyCode(),
      productCode: this.getProductCode()
    });
  }

  private initCompanyBeforeLogon(): Observable<any> {
    const companyCode = this.getCompanyCode();
    const productCode = this.getProductCode();

    if (!companyCode) {
      return of(false);
    }

    this.themeService.setTheme('companyTheme', companyCode);

    return this.companyService.init({ companyCode, productCode });
  }

  private getCompanyCode(): string {
    const userCompany = this.authService.getAuthUserAttributes().company;

    if (!!userCompany) {
      return userCompany;
    } else if (location.hostname.indexOf('avverafinanziamenti') > -1) {
      return '041';
    } else if (location.hostname.indexOf('credem') > -1) {
      return '001';
    } else {
      return '';
    }
  }

  private getProductCode(): string {
    return this.authService.getAuthUserAttributes()['product-code'] || '';
  }
}
